import { useState } from 'react'
import { Section } from '../components'
import { ChecklistPhase } from '@oneethos/shared'
import { ChecklistItemsConfig } from '../components'

export const ChecklistItemsConfigPage = () => {
  const [nav, setNav] = useState<ChecklistPhase>(ChecklistPhase.LoanApplication)
  return (
    <Section>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <h2>Checklist Items Config</h2>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <span
                  className={`nav-link ${nav === ChecklistPhase.LoanApplication ? 'active' : ''}`}
                  onClick={() => setNav(ChecklistPhase.LoanApplication)}
                >
                  Loan Application
                </span>
              </li>
              <li className="nav-item">
                <span
                  className={`nav-link ${nav === ChecklistPhase.LoanFunding ? 'active' : ''}`}
                  onClick={() => setNav(ChecklistPhase.LoanFunding)}
                >
                  Loan Funding
                </span>
              </li>
            </ul>
            <ChecklistItemsConfig currentPhase={nav} />
          </div>
        </div>
      </div>
    </Section>
  )
}
